import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { GatsbyImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import CaretakersServices from '../../../services/caretakers-services';
import Button from '../../../shared/components/atoms/button/button';
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import useMobile from "../../../shared/hooks/useMobile";
import { localStorage } from '../../../shared/utils/storage';
import RedeemModuleModal from '../redeem-module-modal/redeem-module-modal';
import SuccessfulRedemptionModal from '../successful-redemption-modal/successful-redemption-modal';
import './section-single-module-introduction.scss';

const SectionSingleModuleIntroduction = ({ contentInfo, modalData, setActiveModal, userData, moduleState, setToast, modulesCompleted, moduleIdentifiers, isFinishModule, isBlocked }) => {


    const { homeLink } = useHomeLinkMode();
    const mobile = useMobile()

    const [currentButton, setCurrentButton] = useState("redeem");

    const onboarding = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p >{next}</p>
        }
    };

    const item = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-m-single-module-introduction__list-item-paragraph">{next}</p>,
            [INLINES.HYPERLINK]: (node, next) => <a className="f-m-single-module-introduction__list-item-link" href={(node.data.uri.includes('https') || node.data.uri.includes('www')) ? (node.data.uri) : (homeLink + node.data.uri)} rel="noopener noreferrer" target="_blank">{next}</a>
        }
    };

    const extra = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p >{next}</p>
        }
    };

    const redeemModule = () => {
        const tokenInfo = localStorage.getItem('TOKEN_INFO') ? localStorage.getItem('TOKEN_INFO') : null
        if (tokenInfo) {

            const payload = {
                "cmsId": moduleIdentifiers.cmsId,
                "courseId": moduleIdentifiers.courseId,
                "moduleNumber": moduleIdentifiers.moduleNumber
            }

            let config = {
                headers: {
                    Authorization: tokenInfo.idToken,
                },
            }

            CaretakersServices.redeemModule(payload, config).then(
                response => {
                    if (response.status === 200) {
                        setActiveModal(
                            <SuccessfulRedemptionModal
                                contentInfo={(modalData && modalData[1]) && modalData[1]}
                                buttonCopy={"Entendido"}
                                buttonEvent={() => { setCurrentButton("solution-state"); setActiveModal(null) }}
                                closeModal={() => { setCurrentButton("solution-state"); setActiveModal(null) }}
                            />
                        )
                    } else {
                        setToast({
                            messageToast: response.userMessage,
                            checkToast: false
                        })
                    }
                }
            ).catch(error => {
                console.error(error)
            })
        }
    }

    const downloadPDF = () => {
        const tokenInfo = localStorage.getItem('TOKEN_INFO') ? localStorage.getItem('TOKEN_INFO') : null
        if (tokenInfo) {

            const payload = "?courseId=" + moduleIdentifiers.courseId

            let config = {
                headers: {
                    Authorization: tokenInfo.idToken
                },
                responseType: 'arraybuffer',
            }

            CaretakersServices.generateDiploma(payload, config).then(
                response => {
                    try {
                        const file = new Blob([response], { type: "application/pdf" });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(file);
                        const fileName = "Diploma_" + userData.name + " " + userData.lastName;
                        link.download = fileName;
                        link.click();
                    } catch (e) {
                        console.error(e);
                    }
                }
            ).catch(error => {
                console.error(error)
            })
        }
    }

    const getButtons = (type) => {
        if (isFinishModule) {
            return <div className="f-m-single-module-introduction__finished-state">
                <p>La temporada 12 del Curso de Cuidadores ha finalizado</p>
            </div>
        } else {
            switch (type) {
                case "redeem":
                    return (
                        <div className="f-m-single-module-introduction__button-redeem">
                            < Button
                                className={"f-a-button__primary-purple f-a-button__extra-big "}
                                copy={(localStorage.getItem("TOKEN_INFO")) ? contentInfo.textoBoton : "Inicia el curso"}
                                onclick={() => {
                                    if ((localStorage.getItem("TOKEN_INFO"))) {
                                        setActiveModal(
                                            <RedeemModuleModal
                                                mainCopy={(modalData && modalData[0]) ? modalData[0].tituloGeneral : ""}
                                                missingPointsCopy="No tienes suficientes puntos para redimir este módulo."
                                                rewardImage={(modalData && modalData[0]) && modalData[0].imagen}
                                                rewardCost={(modalData && modalData[0]) ? parseInt(modalData[0].textoBoton) : 30}
                                                userData={userData}
                                                acceptCopy="Redimir módulo"
                                                acceptEvent={() => { redeemModule() }}
                                                cancelCopy="Cancelar"
                                                cancelEvent={() => { setActiveModal(null) }}
                                                closeModal={() => { setActiveModal(null) }}
                                            />
                                        )
                                    } else {
                                        sessionStorage.setItem('PREVIOUS_PAGE', window.location.href)
                                        location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "autenticacion")
                                    }
                                }}
                                loader={isBlocked ? 'disabled' : ((localStorage.getItem("TOKEN_INFO")) ? (userData ? false : true) : false)}
                            />
                        </div>
                    );
                case "solution-state":
                    return (
                        <div className="f-m-single-module-introduction__solution-state">
                            <a href={contentInfo.redireccionBoton} rel="noopener noreferrer" target="_blank" className="f-m-single-module-introduction__solution-state-button __one">
                                < Button
                                    className={"f-a-button__primary-purple f-a-button__extra-big "}
                                    copy={"Descarga la guía"}
                                    loader={isBlocked ? 'disabled' : ((localStorage.getItem("TOKEN_INFO")) ? (userData ? false : true) : false)}
                                />
                            </a>
                            < Button
                                className={"f-a-button__secondary-purple f-a-button__extra-big f-m-single-module-introduction__solution-state-button"}
                                copy={moduleState.evaluationSolved ? "Ver autoevaluación" : "Ir a autoevaluación"}
                                onclick={() => { location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "curso-de-cuidadores/") + "autoevaluacion/?courseId=" + moduleIdentifiers.courseId + "&moduleNumber=" + moduleIdentifiers.moduleNumber }}
                                loader={isBlocked ? 'disabled' : ((localStorage.getItem("TOKEN_INFO")) ? (userData ? false : true) : false)}
                            />
                        </div>
                    );
                case "modules-completes":
                    return (
                        <div className="f-m-single-module-introduction__completed-state">
                            <a href={contentInfo.redireccionBoton} rel="noopener noreferrer" target="_blank" className="f-m-single-module-introduction__completed-state-button __one">
                                < Button
                                    className={"f-a-button__primary-purple f-a-button__extra-big "}
                                    copy={"Descarga la guía"}
                                    loader={isBlocked ? 'disabled' : ((localStorage.getItem("TOKEN_INFO")) ? (userData ? false : true) : false)}
                                />
                            </a>
                            < Button
                                className={"f-a-button__secondary-purple f-a-button__extra-big f-m-single-module-introduction__completed-state-button"}
                                copy={"Descarga tu diploma aquí"}
                                onclick={() => { downloadPDF() }}
                            />
                        </div>
                    );
            }
        }
    }

    return (
        <section className="f-m-single-module-introduction">
            <div className="f-m-single-module-introduction__content">
                <div className="f-m-single-module-introduction__upper">
                    <div className="f-m-single-module-introduction__text">
                        {mobile &&
                            <>
                                <p className="f-m-single-module-introduction__onboarding-title">{contentInfo.tituloGeneral}</p>

                                <div className="f-m-single-module-introduction__main-image-container">
                                    <GatsbyImage
                                        image={contentInfo.imagen[0].gatsbyImageData}
                                        alt={contentInfo.imagen[0].description}
                                        className="f-m-single-module-introduction__main-image"
                                    />
                                </div>
                            </>
                        }
                        <div className="f-m-single-module-introduction__onboarding">
                            {!mobile && <p className="f-m-single-module-introduction__onboarding-title">{contentInfo.tituloGeneral}</p>}
                            {contentInfo.descripcion.raw && documentToReactComponents(JSON.parse(contentInfo.descripcion.raw), onboarding)}
                        </div>
                        <ul className="f-m-single-module-introduction__list">
                            {mobile ?
                                contentInfo.listaContenidos && contentInfo.listaContenidos.map((info, index) => {
                                    return (
                                        <li key={index} className="f-m-single-module-introduction__list-item">
                                            {info.descripcion.raw && documentToReactComponents(JSON.parse(info.descripcion.raw), item)}
                                        </li>
                                    )
                                })
                                :
                                <li className="f-m-single-module-introduction__list-item">
                                    {contentInfo.listaContenidos[0].descripcion.raw && documentToReactComponents(JSON.parse(contentInfo.listaContenidos[0].descripcion.raw), item)}
                                </li>
                            }
                        </ul>
                    </div>

                    {!mobile &&
                        <div className="f-m-single-module-introduction__main-image-container">
                            <GatsbyImage
                                image={contentInfo.imagen[0].gatsbyImageData}
                                alt={contentInfo.imagen[0].description}
                                className="f-m-single-module-introduction__main-image"
                            />
                        </div>
                    }
                </div>
                {!mobile &&
                    <div className="f-m-single-module-introduction__lower">
                        <div className="f-m-single-module-introduction__secondary-image-container">
                            <div className="f-m-single-module-introduction__secondary-image-background"></div>
                            <GatsbyImage
                                image={contentInfo.imagen[1].gatsbyImageData}
                                alt={contentInfo.imagen[1].description}
                                className="f-m-single-module-introduction__secondary-image"
                            />
                        </div>
                        <div className="f-m-single-module-introduction__text">
                            <ul className="f-m-single-module-introduction__list">
                                <li className="f-m-single-module-introduction__list-item">
                                    {contentInfo.listaContenidos[1].descripcion.raw && documentToReactComponents(JSON.parse(contentInfo.listaContenidos[1].descripcion.raw), item)}
                                </li>
                                <li className="f-m-single-module-introduction__list-item">
                                    {contentInfo.listaContenidos[2].descripcion.raw && documentToReactComponents(JSON.parse(contentInfo.listaContenidos[2].descripcion.raw), item)}
                                </li>

                            </ul>
                            {moduleState ?

                                moduleState.previousEvaluationSolved ?
                                    <div className="f-m-single-module-introduction__buttons-container">
                                        {getButtons(moduleState.redeemedModule ? (moduleState.showEvaluacionSolved ? ("solution-state") : (modulesCompleted ? "modules-completes" : "solution-state")) : currentButton)}
                                    </div>
                                    :
                                    <p className="f-m-single-module-introduction__not-completed-before">¡Aún no has completado la autoevaluación del módulo anterior! Complétala para poder avanzar.</p>

                                :
                                <div className="f-m-single-module-introduction__buttons-container">
                                    {getButtons(currentButton)}
                                </div>
                            }
                        </div>
                    </div>
                }
                {mobile &&
                    <>
                        {moduleState ?

                            moduleState.previousEvaluationSolved ?
                                <div className="f-m-single-module-introduction__buttons-container">
                                    {getButtons(moduleState.redeemedModule ? (moduleState.showEvaluacionSolved ? ("solution-state") : (modulesCompleted ? "modules-completes" : "solution-state")) : currentButton)}
                                </div>
                                :
                                <p className="f-m-single-module-introduction__not-completed-before">¡Aún no has completado la autoevaluación del módulo anterior! Complétala para poder avanzar.</p>

                            :
                            <div className="f-m-single-module-introduction__buttons-container">
                                {getButtons(currentButton)}
                            </div>
                        }
                    </>
                }
                <div className="f-m-single-module-introduction__acquarella">
                    {contentInfo.contenidoAquarella.raw && documentToReactComponents(JSON.parse(contentInfo.contenidoAquarella.raw), extra)}
                </div>


            </div>
        </section>
    )
}

export default SectionSingleModuleIntroduction
